export default "__VITE_ASSET__ba55bd01__"